import axios from 'axios';
import URLs from '../../utils/url';
import axiosClient from './apiClient';

let cancelToken: any;

export const fetchProduct = (url: string, type = 1) => {
  if (typeof cancelToken != typeof undefined) {
    cancelToken.cancel('Operation canceled due to new request.');
  }

  cancelToken = axios.CancelToken.source();

  if (type === 1) {
    return axiosClient.get(`${URLs.apisV1}${url}`, { cancelToken: cancelToken.token });
  } else if (type === 2) {
    return axiosClient.get(`${URLs.apisV2}${url}`, { cancelToken: cancelToken.token });
  } else if (type === 3) {
    return axiosClient.get(`${URLs.apisV2}${url}`, { cancelToken: cancelToken.token });
  }
};

export const postProduct = (data: any) => {
  return axiosClient.post(`${URLs.apisV2}${URLs.CREATE_PRODUCT}`, data);
};
